<template>
  <router-link
    :to="returnRoute"
    class="my-profile-button link link--unstyled"
    data-test-id="profile-back-button"
  >
    <icon-component name="caret" class="my-profile-button__icon icon--small" />
    <span class="my-profile-button__text">
      <slot>{{ profileButtonText }}</slot>
    </span>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MyProfileButton',
  props: {
    link: {
      type: Object,
      default: () => ({ name: 'userProfileOverview' }),
    },
  },
  data() {
    return {
      returnRoute: {},
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isMemberProfileRoute() {
      return /memberProfile/i.test(this.$route.name);
    },
    isMemberRouteAndNotCurrentUser() {
      return this.isMemberProfileRoute && this.$route.params.slug !== this.currentUser.slug;
    },
    profileButtonText() {
      return this.isMemberRouteAndNotCurrentUser ? 'Profile' : 'My Profile';
    },
  },
  created() {
    if (this.isMemberRouteAndNotCurrentUser) {
      this.returnRoute = {
        name: 'memberProfile',
        params: { slug: this.$route.params.slug },
      };
    } else {
      this.returnRoute = this.link;
    }
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_my-profile-button';
</style>
